// extracted by mini-css-extract-plugin
export default {"container":"_23R1Zhhy0XE6HruLnhB7Ui","description":"_1QCB_uRWSWILM_SYRKhhWD"};